import clsx from 'clsx';
import Card from './Card';

/**
 * Card de seção padronizado do backoffice: ícone + título + descrição + ações.
 * Garante hierarquia visual consistente entre todas as abas.
 */
export default function SectionCard({ icon: Icon, title, description, actions, children, className }) {
  return (
    <Card className={clsx('p-4 sm:p-5', className)}>
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-2.5">
          {Icon && (
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent/10 text-accent">
              <Icon size={18} strokeWidth={1.75} />
            </span>
          )}
          <div className="min-w-0">
            <h3 className="font-semibold leading-tight text-zinc-100">{title}</h3>
            {description && <p className="mt-0.5 text-sm leading-relaxed text-zinc-400">{description}</p>}
          </div>
        </div>
        {actions && <div className="flex flex-shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {children}
    </Card>
  );
}
